import {
  cancelOrder,
  createDraft,
  createOrder,
  createSchedule,
  deleteSchedule,
  finishOrder,
  getDraft,
  getOrder,
  getOrderMenu,
  getOrders,
  getOrderSettings,
  getSchedule,
  getSchedules,
  updateDraft,
  updateEntreeLimits,
  updateOrder,
  updateSchedule,
  updateScheduleVer2,
  updateTime,
} from '@/api/orders';
import { snackbar } from '@/plugins/snackbar';
import { DRAFT_GET_TYPES, SNACKBAR_TYPES } from '@/utils/constants';
import { toCamelCase } from '@/utils/caseConvertor';

import {
  CANCEL_ORDER,
  CREATE_DRAFT,
  CREATE_ORDER,
  CREATE_SCHEDULE,
  CREATING_ORDER,
  CREATING_SCHEDULE,
  DELETE_SCHEDULE,
  FINISH_ORDER,
  GET_DRAFT,
  GET_ORDER_MENU,
  GET_ORDER,
  GET_ORDERS_DONE,
  GET_ORDERS,
  GET_SCHEDULE,
  GET_SCHEDULES_DONE,
  GET_SCHEDULES,
  GETTING_ORDERS,
  GETTING_SCHEDULES,
  IS_GETTING_DRAFT,
  SET_DRAFT_ORDER,
  SET_SCHEDULE,
  UPDATE_DRAFT,
  UPDATE_ENTREE_LIMITS,
  UPDATE_ORDER_TIME,
  UPDATE_ORDER,
  UPDATE_SCHEDULE,
  UPDATE_SCHEDULE_VER2,
} from './constants';

export default {
  async [CREATE_ORDER]({ commit }, data) {
    try {
      commit(CREATING_ORDER, true);
      const order = await createOrder(data);
      return order;
    } finally {
      commit(CREATING_ORDER, false);
    }
  },
  async [CREATE_SCHEDULE]({ commit }, data) {
    try {
      commit(CREATING_SCHEDULE, true);
      const order = await createSchedule(data);
      return order;
    } finally {
      commit(CREATING_SCHEDULE, false);
    }
  },
  async [GET_ORDERS]({ commit }, payload) {
    commit(GETTING_ORDERS, true);
    try {
      const res = await getOrders(payload);
      commit(GET_ORDERS_DONE, res);
    } catch (error) {
      const { message = '' } = error;
      snackbar({ type: SNACKBAR_TYPES.ERROR, msg: `取得訂單失敗。(錯誤：${message})` });
      commit(GET_ORDERS_DONE, {});
    } finally {
      commit(GETTING_ORDERS, false);
    }
  },
  async [GET_SCHEDULES]({ commit }, payload) {
    commit(GETTING_SCHEDULES, true);
    try {
      const res = await getSchedules(payload);
      commit(GET_SCHEDULES_DONE, res);
    } catch (error) {
      const { message = '' } = error;
      snackbar({ type: SNACKBAR_TYPES.ERROR, msg: `取得例行性訂購排程失敗。(錯誤：${message})` });
      commit(GET_SCHEDULES_DONE, {});
    } finally {
      commit(GETTING_SCHEDULES, false);
    }
  },
  async [GET_ORDER](ctx, id) {
    const order = await getOrder(id);
    return order;
  },
  async [GET_ORDER_MENU](ctx, id) {
    const menu = await getOrderMenu(id);
    return menu;
  },
  async [UPDATE_ORDER](ctx, { id, data }) {
    await updateOrder(id, data);
  },
  async [CANCEL_ORDER](ctx, id) {
    await cancelOrder(id);
  },
  async [FINISH_ORDER](ctx, id) {
    await finishOrder(id);
  },
  async [UPDATE_ORDER_TIME](ctx, { id, config }) {
    await updateTime(id, config);
  },
  async [GET_DRAFT]({ commit }, { id, type = DRAFT_GET_TYPES.CREATE }) {
    commit(IS_GETTING_DRAFT, true);
    try {
      const isTypeEdit = type === DRAFT_GET_TYPES.EDIT;
      const res = isTypeEdit ? await getOrderSettings(id) : await getDraft(id);
      const { team_group_buying: draft = {} } = res || {};
      commit(SET_DRAFT_ORDER, toCamelCase(draft));
      return Promise.resolve(draft);
    } catch (error) {
      commit(SET_DRAFT_ORDER, {});
      return Promise.reject(error);
    } finally {
      commit(IS_GETTING_DRAFT, false);
    }
  },
  async [GET_SCHEDULE]({ commit }, id) {
    commit(IS_GETTING_DRAFT, true);
    try {
      const res = await getSchedule(id);
      commit(SET_SCHEDULE, toCamelCase(res));
      return Promise.resolve(toCamelCase(res));
    } catch (error) {
      commit(SET_DRAFT_ORDER, {});
      return Promise.reject(error);
    } finally {
      commit(IS_GETTING_DRAFT, false);
    }
  },
  async [CREATE_DRAFT](ctx, data) {
    try {
      const { team_group_buying: draft } = await createDraft(data);
      return Promise.resolve(draft);
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async [UPDATE_DRAFT](ctx, { id, data }) {
    try {
      await updateDraft(id, data);
      return Promise.resolve();
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async [UPDATE_ENTREE_LIMITS](ctx, { id, data }) {
    try {
      await updateEntreeLimits(id, data);
      return Promise.resolve();
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async [DELETE_SCHEDULE](ctx, id) {
    try {
      await deleteSchedule(id);
      return Promise.resolve();
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async [UPDATE_SCHEDULE](ctx, data) {
    try {
      const schedule = await updateSchedule(data);
      return Promise.resolve(schedule);
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async [UPDATE_SCHEDULE_VER2](ctx, data) {
    try {
      const schedule = await updateScheduleVer2(data);
      return Promise.resolve(schedule);
    } catch (error) {
      return Promise.reject(error);
    }
  },
};
